import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/bpreportitem/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/bpreportitem/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/bpreportitem/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/bpreportitem/submit',
    method: 'post',
    data: row
  })
}

